const filterByPerspective = (items, perspective) => items.filter(
  ({ perspective: itemPerspective }) => perspective === "default" ? !itemPerspective || itemPerspective === "default" : perspective === itemPerspective
);
export default filterByPerspective;
